export enum IntegrationsRoutes {
  root = 'integrations',
  settings = 'settings',
  description = 'description',
  webhooks = 'webhooks',
  create = 'create',
  edit = 'edit',
  history = 'history',
}
